"use client";

/**
 * TranslateButton
 * Floating Eqqo-powered language selector for the public landing page.
 * The TranslatorProvider that powers translation lives in V2LandingPagePublicWrapper.
 */

import { LanguageSelector } from "eqqo-react";
import { EQQO_SUPPORTED_LANGUAGES } from "@/features/enterprise-sidebar/_logic/constants";

/**
 * Floating bottom-left language selector. `LanguageSelector` self-positions
 * via its `position` prop; optional children (e.g. the organizer "Edit Landing
 * Page" button) stack vertically just above the selector at the same edge.
 *
 * @param children - Optional sibling rendered above the language selector
 */
export function TranslateButton({ children }: { children?: React.ReactNode }) {
  return (
    <>
      <LanguageSelector languages={EQQO_SUPPORTED_LANGUAGES} variant="searchable" position="bottomLeft" />
      {children && (
        <div className="fixed bottom-5 left-20 z-50" data-no-translate="true">
          {children}
        </div>
      )}
    </>
  );
}
